import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { BubzLogo } from "./BubzLogo";

export default function ComingSoonPopup() {
  const [open, setOpen] = useState(true);
  return (
    <AnimatePresence>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4" data-testid="coming-soon-popup">
          <motion.div initial={{ scale: 0.85, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="relative w-full max-w-lg rounded-[2rem] bg-gradient-to-br from-[#FF5A79] via-[#FF7A59] to-[#FFC02D] p-1 shadow-2xl">
            <div className="rounded-[1.8rem] bg-[#FFFDF7] px-8 py-12 text-center">
              <button onClick={() => setOpen(false)} data-testid="coming-soon-close-btn" aria-label="Close"
                className="absolute top-5 right-5 h-10 w-10 rounded-full bg-white/90 hover:bg-white text-slate-500 hover:text-slate-800 shadow flex items-center justify-center transition-colors">
                <X className="h-5 w-5" />
              </button>
              <div className="flex justify-center animate-floaty"><BubzLogo size="xl" /></div>
              <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl text-slate-900 tracking-tight" data-testid="coming-soon-title">BUBZ+</h2>
              <p className="mt-3 font-display font-bold text-2xl sm:text-3xl text-[#FF5A79]" data-testid="coming-soon-text">COMING SOON</p>
              <p className="mt-2 inline-block rounded-full bg-[#9B5DE5] text-white px-5 py-1.5 text-sm sm:text-base font-bold tracking-widest" data-testid="coming-soon-date">LATE 2027</p>
              <button onClick={() => setOpen(false)} data-testid="coming-soon-continue-btn"
                className="mt-8 block mx-auto text-sm font-semibold text-slate-500 hover:text-slate-800 underline-offset-4 hover:underline">
                Already a member? Sign in
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
